import i18n from '@/lib/i18n';

/** Strings of the AHV pilot onboarding (ADR 0021): key-pair credentials and the WhatsApp consent registry. */
const en = {
  pilot: {
    keys: {
      title: 'Key pair (private_key_jwt)',
      description:
        'jd enterprise authenticates agent accounts with a signed key (EC P-256). The private key stays in the platform; send only the public key to the jobdesk® enterprise API admin.',
      generate: 'Generate key pair',
      regenerate: 'Generate new key pair (rotation)',
      publicJwk: 'Public key (JWK) for the jobdesk® enterprise API admin',
      copy: 'Copy',
      copied: 'Copied',
      thumbprint: 'Thumbprint {{value}}',
      active: 'Active key',
      pending: 'New key waiting for verification',
      noKey: 'No key yet.',
      keyId: 'Key ID (kid)',
      keyIdHelp: 'The key id the jobdesk® enterprise API registered for the public key.',
      instructions: 'Send this JWK to the jobdesk® enterprise API admin and ask for an internal account <tenantId>.jdap with the internal scopes contacts.ahv.read and contacts.ahv.write. Enter the client id and key id you get back, then verify.',
      mode: 'Authentication: {{mode}}',
      scopeSource: 'Scopes from {{source}}',
    },
    consents: {
      title: 'WhatsApp consent',
      description:
        'jd enterprise only lists contacts who consented. Opt-outs (STOP) are recorded here and always win. Only an attested manual opt-in can lift an opt-out.',
      number: 'Phone number',
      status: 'Status',
      source: 'Source',
      at: 'Recorded',
      by: 'By',
      evidence: 'Evidence',
      optedIn: 'Opted in',
      optedOut: 'Opted out',
      markOptOut: 'Record opt-out',
      markOptIn: 'Record opt-in',
      attestation: 'Attestation (when and how the person consented)',
      attestationRequired: 'An opt-in needs an attestation.',
      contactRef: 'Contact reference (optional)',
      export: 'Export CSV',
      empty: 'No consent records yet.',
      filterAll: 'All',
    },
  },
};

const de = {
  pilot: {
    keys: {
      title: 'Schlüsselpaar (private_key_jwt)',
      description:
        'jd enterprise authentifiziert Agent-Konten mit einem signierten Schlüssel (EC P-256). Der private Schlüssel bleibt in der Plattform; nur den öffentlichen Schlüssel an den Admin der jobdesk® enterprise API senden.',
      generate: 'Schlüsselpaar erzeugen',
      regenerate: 'Neues Schlüsselpaar erzeugen (Rotation)',
      publicJwk: 'Öffentlicher Schlüssel (JWK) für den Admin der jobdesk® enterprise API',
      copy: 'Kopieren',
      copied: 'Kopiert',
      thumbprint: 'Fingerprint {{value}}',
      active: 'Aktiver Schlüssel',
      pending: 'Neuer Schlüssel wartet auf Prüfung',
      noKey: 'Noch kein Schlüssel.',
      keyId: 'Key-ID (kid)',
      keyIdHelp: 'Die Key-ID, die die jobdesk® enterprise API für den öffentlichen Schlüssel registriert hat.',
      instructions: 'Diesen JWK an den Admin der jobdesk® enterprise API senden und ein internes Konto <tenantId>.jdap mit den internen Scopes contacts.ahv.read und contacts.ahv.write anfordern. Die erhaltene Client-ID und Key-ID eintragen und prüfen.',
      mode: 'Authentifizierung: {{mode}}',
      scopeSource: 'Scopes aus {{source}}',
    },
    consents: {
      title: 'WhatsApp-Einwilligung',
      description:
        'jd enterprise listet nur Kontakte mit Einwilligung. Abmeldungen (STOP) werden hier gespeichert und gelten immer. Nur ein bestätigtes manuelles Opt-in hebt eine Abmeldung auf.',
      number: 'Telefonnummer',
      status: 'Status',
      source: 'Quelle',
      at: 'Erfasst',
      by: 'Von',
      evidence: 'Nachweis',
      optedIn: 'Eingewilligt',
      optedOut: 'Abgemeldet',
      markOptOut: 'Abmeldung erfassen',
      markOptIn: 'Einwilligung erfassen',
      attestation: 'Bestätigung (wann und wie die Person eingewilligt hat)',
      attestationRequired: 'Eine Einwilligung braucht eine Bestätigung.',
      contactRef: 'Kontaktreferenz (optional)',
      export: 'CSV exportieren',
      empty: 'Noch keine Einträge.',
      filterAll: 'Alle',
    },
  },
};

i18n.addResourceBundle('en', 'translation', en, true, false);
i18n.addResourceBundle('de', 'translation', de, true, false);

export {};
